// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs--3gtst","open":"open--AmPg0","crumb":"crumb--3elwn"};